export default __webpack_public_path__ + "6139d2b783296eb08b85039b9759253e.png";